/** Page gating by permission switches: small, loaded with the app shell (the labels live in access.ts). */
import type { Snapshot } from "../../api";

/** The permission switches in the core (`permissions`, server features/permissions.ts). */
export type Permissions = {
  seeCosts: boolean;
  approveInvoices: boolean;
  finalizeCounts: boolean;
  order: boolean;
  editCatalog: boolean;
  viewReports: boolean;
  financialExportsOnly: boolean;
};
/** Pages hidden from the navigation by a person's switches (the server refuses them anyway). */
export function pageAllowed(s: Snapshot, pageId: string): boolean {
  const p = s.permissions as Permissions | undefined;
  if (!p || s.role === "owner") return true;
  if (p.financialExportsOnly) return ["today", "accounting", "account", "help"].includes(pageId);
  if (!p.seeCosts && ["invoices", "costing", "deposits", "accounting", "company"].includes(pageId)) return false;
  if (!p.viewReports && ["reports", "costing", "accounting", "company"].includes(pageId)) return false;
  return true;
}
